import { FC } from "react";
import { twMerge } from "tailwind-merge";
import { RECAPTCHA_SITE_KEY } from "@/utils/recaptcha";

interface RecaptchaNoticeProps {
  className?: string;
}

/**
 * Required attribution when the floating reCAPTCHA badge is hidden.
 * Renders nothing when reCAPTCHA is disabled, so the claim stays truthful.
 */
const RecaptchaNotice: FC<RecaptchaNoticeProps> = ({ className }) => {
  if (!RECAPTCHA_SITE_KEY) return null;

  return (
    <p className={twMerge("text-center text-xs text-gray-400", className)}>
      Trang này được bảo vệ bởi reCAPTCHA và tuân theo{" "}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Chính sách bảo mật
      </a>{" "}
      và{" "}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Điều khoản dịch vụ
      </a>{" "}
      của Google.
    </p>
  );
};

export default RecaptchaNotice;
